import React from 'react';
import { useRouter } from 'next/router';
import BSPagination from 'react-bootstrap/Pagination';
import { usePagination, DOTS } from '@/components/Pagination/hooks/usePagination';
import styles from './BlogPagination.module.scss';

export interface IPagination {
  pageCount?: number;
  currentPage?: number;
  getUrl: (i: number) => string;
  boundaries?: number;
  siblings?: number;
}

export const Pagination = ({ pageCount = 0, currentPage = 1, getUrl }: IPagination) => {
  const router = useRouter();
  const pagination = usePagination({
    page: currentPage,
    total: pageCount
  });

  const handlePageChange = (newPage: number) => {
    const url = getUrl(newPage);
    router.push(url);
  };

  return (
    <div className={styles.paginationContainer}>
      {pageCount !== 0 && (
        <BSPagination>
          <BSPagination.Prev
            href={getUrl(currentPage - 1)}
            onClick={(e) => {
              e.preventDefault();
              if (currentPage > 1) {
                handlePageChange(currentPage - 1);
              }
            }}
            rel="prev"
            disabled={currentPage === 1}
          />
          {pagination.range.map((page, idx) => {
            if (page === DOTS) {
              return <BSPagination.Ellipsis key={idx} disabled />;
            }
            return (
              <BSPagination.Item
                key={idx}
                active={page === currentPage}
                href={getUrl(page)}
                onClick={(e) => {
                  e.preventDefault();
                  handlePageChange(page);
                }}
              >
                {page}
              </BSPagination.Item>
            );
          })}
          <BSPagination.Next
            href={getUrl(currentPage + 1)}
            onClick={(e) => {
              e.preventDefault();
              if (currentPage < pageCount) {
                handlePageChange(currentPage + 1);
              }
            }}
            rel="next"
            disabled={currentPage === pageCount}
          />
        </BSPagination>
      )}
    </div>
  );
};
